/**
 * @file Re-exports the contact-us entry point.
 */
import ContactUs from "./ContactUs";

export default ContactUs;
